<template>
    <!--
        PRODUCT-26110 Phase 2B2: this root div used to be `id="root"`. Vue 2's $mount
        REPLACED the index.html mount container (also `#root`), so the two collapsed into
        one element and `#root > ...` selectors targeted this component's children. Vue 3
        renders INTO the container instead, which nested a second `#root` inside the first
        (duplicate ids) and made `#root > :not(.ModalTarget)` blur the wrapper that
        contains the ModalTarget -- i.e. the open modal itself was blurred. The inner div
        now carries a class and the blur selectors are anchored through it.
    -->
    <div class="Main">
        <router-view v-if="isStandaloneRoute" />
        <Page v-else>
            <router-view />
        </Page>
        <component
            :is="Component"
            v-for="(Component, index) in topLevelComponents"
            :key="`${Component.name}-${index}`"
        />
        <ModalTarget parent-class-name-opened="body--modalOpened" />
        <!-- PRODUCT-26110 Task 8b Step 2: portal-vue's <portal-target> -> a plain div
             with the same id Popover.vue's `<Teleport :to>` targets. -->
        <div id="default-popover-target" class="PopoverTarget" />
        <ProcedureTarget hide-container disable-routing-during-procedure />
    </div>
</template>

<style lang="scss">
    // stylelint-disable selector-max-combinators, selector-max-compound-selectors, selector-no-qualifying-type
    body.body--modalOpened {
        overflow: hidden;

        #root > .Main > :not(.ModalTarget):not(.Snackbar),
        #root > .Main > .ModalTarget > :not(.Modal) {
            filter: blur(5px);
        }
    }

    .PopoverTarget {
        position: relative;
        //TODO[PRODUCT-25175] establish z-index variables and refactor to use
        z-index: 100000;
    }
</style>

<script lang="ts">
    import { Vue, Component } from '@evidentid/vue-property-decorator';

    import { ModalTarget } from '@evidentid/dashboard-commons/components/Modal';
    import { ProcedureTarget } from '@evidentid/dashboard-commons/components/ProcedureManager';

    import Page from '@/components/page/Page.vue';

    const STANDALONE_ROUTES = [
        // Auth routes - use their own full-screen layout with Loading component
        'auth.login',
        'auth.check',
        'auth.verify',
        'auth.terms',
        'auth.terms.redirect',
        'auth.register',
        'auth.resetPassword',
        // Error routes - use their own full-screen ErrorScreen layout
        'error',
        'error.rp',
        'error.application',
        'error.generic',
        // Standalone example pages - no RP selector, no main layout (matches all examples.* routes)
        'examples',
    ];

    @Component({
        components: { ProcedureTarget, ModalTarget, Page },
    })
    export default class Main extends Vue {
        private get topLevelComponents(): Vue[] {
            return (this as any).$slotComponents.topLevel || [];
        }

        private get isStandaloneRoute(): boolean {
            const name = String(this.$route.name || '');
            return STANDALONE_ROUTES.some((r) => name === r || name.startsWith(`${r}.`));
        }
    }
</script>
